const Enums = Object.freeze({
    CodeRequestTypes: Object.freeze({
        LOGIN: Symbol("CodeRequestTypes.LOGIN"),
        REGENERATE_RECOVERY_CODES: Symbol("CodeRequestTypes.REGENERATE_RECOVERY_CODES"),
        UNBIND_AUTHENTICATOR: Symbol("CodeRequestTypes.UNBIND_AUTHENTICATOR"),
        ADMIN_ACCESS: Symbol("CodeRequestTypes.ADMIN_ACCESS"),
    }),
    ProgressStatus: Object.freeze({
        NOT_STARTED: Symbol("ProgressStatus.NOT_STARTED"),
        IN_PROGRESS: Symbol("ProgressStatus.IN_PROGRESS"),
        COMPLETE: Symbol("ProgressStatus.COMPLETE"),
        SKIPPED: Symbol("ProgressStatus.SKIPPED"),
        ERROR: Symbol("ProgressStatus.ERROR"),
    }),
    DDBImportSteps: Object.freeze({
        PENDING: "pending",
        MANIFEST: "manifest",
        VERIFYING: "verifying",
        DOWNLOADING: "downloading",
        ASSETS: "assets",
        CONVERTING: "converting",
        DEPENDENCY: "dependency",
        CONVERTING_DEPENDENCY: "converting-dependency",
        ASSET_DEPENDENCY: "assets-dependency",
    }),
    GameSessionRepeat: Object.freeze({
        ONCE: 1,
        WEEKLY: 2,
        DAILY: 3,
    }),
    DayOfWeek: Object.freeze({
        SUNDAY: "SU",
        MONDAY: "MO",
        TUESDAY: "TU",
        WEDNESDAY: "WE",
        THURSDAY: "TH",
        FRIDAY: "FR",
        SATURDAY: "SA",
    }),
    PackageVersionCompatibilityStatus: Object.freeze({
        RISKY: -1,
        INCOMPATIBLE: 0,
        COMPATIBLE: 1,
        UNKNOWN: undefined,
    }),
    /**
     * Enum for notification sources.
     * @property {string} SYSTEM - System notification source (used for system-generated notifications).
     * @property {string} MANUAL - Manual notification source (used for manually created notifications).
     * @swagger
     * components:
     *  schemas:
     *    NotificationSource:
     *     type: string
     *     enum: ["SYSTEM", "MANUAL"]
     */
    NotificationSource: Object.freeze({
        SYSTEM: "SYSTEM",
        MANUAL: "MANUAL",
    }),
    /**
     * Enum for notification types.
     * @property {string} CREATOR - Creator notification type (used for creator notifications).
     * @property {string} SYSTEM - System notification type (used for system notifications).
     * @property {string} STAFF - Staff notification type (used for staff notifications).
     * @property {string} USER - User notification type (used for user notifications).
     * @swagger
     * components:
     *  schemas:
     *    NotificationType:
     *     type: string
     *     enum: ["CREATOR", "SYSTEM", "STAFF", "USER"]
     */
    NotificationType: Object.freeze({
        CREATOR: "CREATOR",
        SYSTEM: "SYSTEM",
        STAFF: "STAFF",
        USER: "USER",
    }),
    /**
     * Enum for channel types.
     * @property {string} CREATOR - Creator channel type (used for creator channels).
     * @property {string} SYSTEM - System channel type (used for system messages).
     * @property {string} STAFF - Staff channel type (used for staff messages).
     * @swagger
     * components:
     *  schemas:
     *    ChannelType:
     *     type: string
     *     enum: ["CREATOR", "SYSTEM", "STAFF"]
     */
    ChannelType: Object.freeze({
        CREATOR: "CREATOR",
        SYSTEM: "SYSTEM",
        STAFF: "STAFF",
    }),
});

if (typeof module !== "undefined") {
    // Running in node
    module.exports = {
        Enums,
    };
} else {
    // Running in browser
    window.Enums = Enums;
}
